export default __webpack_public_path__ + "static/media/cor3.227b753f.jpeg";